export default "/fonts/vendor/primeicons/primeicons.woff?8931fda1930c3bd21e96b5a8002f4242";